module.exports = __webpack_public_path__ + "static/etl-5247b718075b3228102d40e48be30d01.png";